import { useMutation, useQueryClient } from "@tanstack/react-query";
import { orbitLOnboardingActionRequiredCountKeys } from "Api/Queries/Merchants/useOrbitLOnboardingActionRequiredCountQuery";
import { orbitLOnboardingDetailKeys } from "Api/Queries/Merchants/useOrbitLOnboardingDetailQuery";
import { orbitLOnboardingListKeys } from "Api/Queries/Merchants/useOrbitLOnboardingListQuery";
import {
  type TmsRegistrationOutcome,
  postMerchantsPublicIDOrbitLRegisterTms,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Parameters = {
  merchantPublicID: string;
};

type Props = {
  onSuccess?: (outcome: TmsRegistrationOutcome) => void;
  onError?: () => void;
};

export const useTriggerTmsRegistrationMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ merchantPublicID }: Parameters) =>
        postMerchantsPublicIDOrbitLRegisterTms(merchantPublicID),
    ),
    onSuccess: (
      outcome: TmsRegistrationOutcome,
      { merchantPublicID }: Parameters,
    ) => {
      queryClient.invalidateQueries({
        queryKey: orbitLOnboardingListKeys.all,
      });
      queryClient.invalidateQueries({
        queryKey: orbitLOnboardingActionRequiredCountKeys.all,
      });
      queryClient.invalidateQueries({
        queryKey:
          orbitLOnboardingDetailKeys.byMerchantPublicId(merchantPublicID),
      });
      onSuccess?.(outcome);
    },
    onError,
  });
};
